// extracted by mini-css-extract-plugin
export default {"btnBox":"wyemL9aiu5Iiz1y0r2gX"};